function algoliaColorSwatchesInit() {
  const query = document.querySelectorAll('.aa-ProductItem[data-unswatched]');
  const { frenchDictionary } = window.SDG;
  query.forEach((prodItem) => {
    let variantColorHandles = '';
    const rollupJson = prodItem.querySelector('#rollupJSON');
    prodItem.removeAttribute('data-unswatched');

    variantColorHandles = JSON.stringify(
      prodItem
        ?.querySelector('[data-variant-info]')
        ?.getAttribute('data-variant-info')
        ?.split(','),
    );
    const colorJSON = variantColorHandles && JSON.parse(variantColorHandles);
    const currentProductHandle = prodItem
      .querySelector('[data-prod-handle]')
      .getAttribute('data-prod-handle');
    colorJSON.push(currentProductHandle);
    let colorsElement;
    const ajaxCalls = [];
    const allColors = [];
    const promiseState = (p) => p.then(
      (v) => ({ v, status: 'fulfilled' }),
      (e) => ({ e, status: 'rejected' }),
    );
    colorJSON.forEach((handle) => {
      if (!handle || handle === '[]') return;
      const cleanedHandle = handle.trim().replace(/['"]+/g, '')
        .replace('[', '').replace(']', '');
      ajaxCalls.push(
        fetch(`/products/${cleanedHandle}?view=json`, { redirect: 'manual' })
          .then((response) => response.json())
          .then((parsedContent) => {
            allColors.push(parsedContent);
            sessionStorage.setItem(cleanedHandle, JSON.stringify(parsedContent));
          })
          .catch((error) => {
            console.warn('not valid JSON for product handle:', cleanedHandle, error);
          }),
      );
    });

    try {
      Promise.all(ajaxCalls.map(promiseState)).then(() => {
        // Sort all the colors alphabetically
        allColors.sort((a, b) => {
          const colorA = a.color;
          const colorB = b.color;
          if (colorA < colorB) return -1;
          if (colorA > colorB) return 1;
          return 0;
        });
        rollupJson.innerText = JSON.stringify(allColors);

        // place current product first in allColors array
        allColors.forEach((colorObj, index) => {
          colorObj.index = index;
          if (colorObj.handle === currentProductHandle) {
            allColors.splice(index, 1);
            allColors.unshift(colorObj);
          }
        });

        // Get the localized price
        const isDefaultLocale = Shopify?.routes?.root === '/';
        const $compareAtPrice = prodItem.querySelector('.js-compare-price',);
        const $price = prodItem.querySelector('.price__sale .js-price');
        const $priceNoDiscount = prodItem.querySelector('.js-price-no-discount');

        if ($compareAtPrice && $price && !isDefaultLocale) {
          $compareAtPrice.innerText = allColors[0].first_variant_compare_at_price;
          $price.innerHTML = allColors[0].first_variant_price;
          $price.classList.remove('hide');
          $compareAtPrice.classList.remove('hide');
        } else if ($priceNoDiscount && !isDefaultLocale) {
          $priceNoDiscount.innerHTML = allColors[0].first_variant_price;
          $priceNoDiscount.classList.remove('hide');
        }

        let activeIndex = 0;
        // Loop through each color
        allColors.forEach((colorObj, index) => {
          const productId = colorObj.id;
          const colorId = `color--${colorObj.id}`;
          const productHandle = colorObj.handle;
          retrieveProduct(index, colorsElement, colorObj, 'product', prodItem);

          // Generating the images
          // Get the rest of the Images
          let imageContent = '';
          let slideshowImages = '';
          let slideShowImageContent = '';

          colorObj.images.forEach((img, index2) => {
            const image = img.src;
            const imageId = img.id;
            const imageAspectRatio = img.aspect_ratio;
            let isVideo = false;
            if (index2 === colorObj.images.length - 1) return; // doesn't include the last image
            if (img.alt === 'featured' || img.alt === 'featured mobile') { return; }
            if (
              img.alt.indexOf('youtube.com/embed') > -1
              || img.alt.indexOf('player.vimeo.com') > -1
            ) { isVideo = true; }

            imageContent = `
              ${imageContent}
              <span
                data-image-id="${imageId}"
                data-color-id="${colorId}"
                class="Product__SlideshowNavImage ${isVideo ? 'Product__SlideshowNavImage--video' : ''} AspectRatio ${index2 === 0 ? 'is-selected' : ''}"
                style="--aspect-ratio: ${imageAspectRatio}"
              >
                <img
                  data-src="${image}"
                  class="lazyload"
                  height="160"
                  width="160"
                  style="height: 160px; width: 160px;"
                >
                  ${isVideo ? '<button type="button" class="Product__SlideshowNavPlay" data-action="play-video"></button>' : ''}
              </span>
            `;
          });

          const prodItemSwatchesArray = Array.from(prodItem.querySelectorAll('.pdp--legacy-swatch__container'));
          const activeSwatchIndex = prodItemSwatchesArray
            .findIndex(($swatchContainer) => $swatchContainer.dataset.active === 'true');
          activeIndex = activeSwatchIndex;
          if (index === activeSwatchIndex || (activeSwatchIndex === -1 && index === 0)) {
            colorObj.images.forEach((img, imgIndex) => {
              if (img.alt === 'color_swatch') return;
              const label = colorObj.title.split('-')[0].trim();
              const imageAlt = window.Shopify.locale === 'fr'
                ? `Visitez la page produit de ${label} pour plus de détails`
                : `Visit ${label} product page for more details`;
              const imageId = img.id;
              const imageSrc = img.src;
              const newImageSrc = imageSrc.replace(/&width=\d+/, '');
              const imageAspectRatio = 0.8005347593582888;
              const imageWidth = img.width;
              const imageHeight = img.height;
              const paddingBottomCalculation = 100.0 / imageAspectRatio;
              const initialImageId = img.featured_image_id;
              const { algoliaPosition } = prodItem.dataset;
              const imageClass = algoliaPosition > 4 && imgIndex === 0 ? 'Image--lazyLoad Image--fadeIn card__image' : 'Image--fadeIn card__image';
              slideShowImageContent = `
                <div class="card__image-wrapper">
                  <div
                    class="AspectRatio AspectRatio--withFallback card__image-aspect-ratio"
                    style="padding-bottom: ${paddingBottomCalculation}%; --aspect-ratio: ${imageAspectRatio}"
                  >
                    <img
                      class="${imageClass}"
                      ${imgIndex >= 1 ? (`
                        loading="lazy"
                        data-flickity-lazyload-srcset="${newImageSrc}&width=135 135w, ${newImageSrc}&width=317 317w, ${newImageSrc}&width=634 634w"
                      `) : (`
                        loading="eager"
                        srcset="${newImageSrc}&width=135 135w, ${newImageSrc}&width=317 317w, ${newImageSrc}&width=634 634w"
                      `)}
                      src="${imageSrc}"
                      data-widths="[135,317,634]"
                      data-sizes="auto"
                      data-expand="-100"
                      alt="${imageAlt}"
                      width="317"
                      height="395"
                      data-max-width="${imageWidth}"
                      data-max-height="${imageHeight}"
                      data-original-src="${imageSrc}"
                      >

                    <span class="Image__Loader"></span>

                    <noscript>
                      <img src="${imageSrc}" alt="${imageAlt}" style="width: 800px; height: 800px;">
                    </noscript>
                  </div>
                </div>
              `;

              slideshowImages = `
                ${slideshowImages}
                <div id="Image${imageId}"
                data-product-id="${productId}"
                data-product-handle="${productHandle}"
                class="Product__SlideItem Product__SlideItem--image card__image-slide Carousel__Cell ${imageId === initialImageId ? 'is-selected' : ''}"
                data-image-position-ignoring-video=${imgIndex}
                data-image-position="${imgIndex}"
                data-image-id="${imageId}"
                role="group"
                aria-label="product item">
                  ${slideShowImageContent}
                </div>
              `;
            });
            const $plpPlaceholder = prodItem.querySelector('.js-plp-image-placeholder');
            if ($plpPlaceholder) $plpPlaceholder.classList.add('hide');
            prodItem.querySelector('._ais-hit--picture')
              .innerHTML = `
              <div class="card__image-carousel" role="region" aria-label="image carousel">
                ${slideshowImages}
              </div>
            `;
          }
        });

        if (activeIndex < 0) {
          prodItem.querySelectorAll('.pdp--legacy-swatch__container').forEach(($swatchContainer, index) => {
            if (index === 0) {
              $swatchContainer.dataset.active = 'true';
            } else {
              $swatchContainer.dataset.active = 'false';
            }
          });
        }

        const $carousel = prodItem.querySelector('.card__image-carousel');
        if ($carousel) {
          // eslint-disable-next-line no-new
          new window.Flickity($carousel, {
            cellAlign: 'left',
            contain: true,
            prevNextButtons: true,
            pageDots: false,
            adaptiveHeight: true,
            lazyLoad: true,
            on: {
              ready: () => {
                // Hide buttons when only one slide
                const $carouselCells = $carousel.querySelectorAll('.Product__SlideItem');
                if ($carouselCells && $carouselCells.length === 1) {
                  const $buttons = $carousel.querySelectorAll('.flickity-button');
                  $buttons.forEach(($button) => {
                    $button.style.display = 'none';
                  });
                }
              }
            },
          });

          // Add click event for keyboard accessible buttons
          // to prevent the link from firing
          $carousel.addEventListener('click', (event) => {
            const isButton = event.target.classList.contains('flickity-button') || event.target.closest('.flickity-button-icon');
            if (!isButton) return;

            event.preventDefault();
          });

          const srSpan = document.createElement("span");
          srSpan.className = "screenreader";
          srSpan.textContent = "This is a carousel with product images. Use the previous and next buttons to navigate.";
          $carousel.prepend(srSpan);
        }

        try {
          const firstSwatchCount = prodItem.querySelectorAll(
            '.swatch-list [data-swatch-prod-available="true"]',
          ).length;
          if (firstSwatchCount > 1) {
            prodItem.querySelector(
              '.available-colors p',
            ).innerHTML = `${firstSwatchCount} color options`;
          }
        } catch (error) {
          console.warn('error counting actual swatches for prod', error);
        }

        document.dispatchEvent(new CustomEvent('swatches:loaded'));

        // format product card URLs for localization
        const formatUrl = (href) => {
          const shopifyRoot = Shopify?.routes?.root;
          if (shopifyRoot === '/' || href.includes(shopifyRoot)) { return href; }
          const hrefSplit = href.split('/');
          const hostnameIndex = hrefSplit.findIndex(
            (split) => split === window.location.hostname,
          );
          const rawRoot = shopifyRoot.replace('/', '').replace('/', '');
          const rootIndex = hostnameIndex + 1;
          hrefSplit.splice(rootIndex, 0, rawRoot);
          const localizedUrl = hrefSplit.join('/');
          return localizedUrl || href;
        };
        const $cardMedia = prodItem.querySelector('.card__media');
        if ($cardMedia) $cardMedia.href = formatUrl($cardMedia.href);

        if (prodItem.querySelector('.swatch-list .more-label')) {
          const swatchIndex = parseInt(prodItem
            .querySelector('.swatch-list .more-label')
            ?.getAttribute('data-extra-swatch-num'), 10);
          const handle = prodItem.querySelector('.card__media')?.href;
          if (handle) {
            prodItem.querySelector('.swatch-list .more-label').href = handle;
          }
          const translatedText = frenchDictionary.filter((item) => item.en === 'color');
          let colorText = 'color';

          if (translatedText.length > 0 && window.Shopify.locale === 'fr') {
            colorText = translatedText[0].fr;
          }
          prodItem.querySelector(
            '.swatch-list .more-label',
          ).innerHTML = `+${swatchIndex} ${colorText.toLowerCase()}${swatchIndex > 1 ? 's' : ''}`;
        }
      });
    } catch (error) {
      console.error('error', error);
    }
  });
}
